import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatCheckboxModule, MatTabsModule, MatTooltipModule } from "@angular/material";
import { RouterModule } from "@angular/router";
import { NgxMaskModule } from "ngx-mask";
import { NgxPrintModule } from "ngx-print";
import { CalendarModule } from "primeng/calendar";
import { CheckboxModule } from "primeng/checkbox";
import { DropdownModule } from "primeng/dropdown";
import { InputSwitchModule } from 'primeng/inputswitch';
import { RadioButtonModule } from "primeng/radiobutton";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { TableModule } from "primeng/table";
import { TabViewModule } from 'primeng/tabview';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TooltipModule } from "primeng/tooltip";
import { AllPipesModule } from "../pipes/all-pipes.module";
import { PageFormArrayComponent } from "./page-form-array";
import { PageHeaderComponent } from "./page-header";
import { PageListTableComponent } from "./page-list-table";
import { PageTabComponent } from "./page-tab";
import { CustomFormControlsModule } from "./reusable-form-controls/custom-form-control/custom-form-controls.module";
import { ViewPageComponent } from "./view-page";
import { ButtonModule } from 'primeng/button';
import { FormControlErrorsModule } from './form-control-errors/form-control-errors.module';

@NgModule({
  declarations: [ViewPageComponent, PageHeaderComponent, PageListTableComponent, PageFormArrayComponent, PageTabComponent],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, AllPipesModule, ScrollPanelModule, RadioButtonModule, FormControlErrorsModule,
    CalendarModule, CustomFormControlsModule, MatCheckboxModule, MatTooltipModule, RouterModule, NgxPrintModule, TooltipModule, CheckboxModule,ButtonModule,
    TableModule, DropdownModule, TieredMenuModule, InputSwitchModule, NgxMaskModule, DragDropModule, MatTabsModule, TabViewModule],
  exports: [ViewPageComponent, PageHeaderComponent, PageListTableComponent, PageFormArrayComponent, PageTabComponent, FormControlErrorsModule],
})
export class PageReusableComponentsModule { }